import script from "./OrderCart.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__